const InfoHeader = ({ label, tooltip }) => {
    return (
        <div
            style={{
                whiteSpace: 'normal',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',

            }}
            title={tooltip}
        >
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {label}
                <span
                    style={{
                        color: '#1976d2',
                        marginLeft: 4,
                        cursor: 'pointer',
                        fontSize: 16,
                        display: 'inline-flex',
                        alignItems: 'center'
                    }}
                    tabIndex={0}
                >
                    <i className="dx-icon-info" />
                </span>
            </span>
        </div>
    );
};
export default InfoHeader;